export enum Permission {
  CustomersAndOrdersView = 'customers_and_orders.view',
}
